import React from "react";
import { motion } from "framer-motion";

const WARNING_IMG =
  "https://images.unsplash.com/photo-1773415418045-ccccfce85a6e?crop=entropy&cs=srgb&fm=jpg&q=85&ixlib=rb-4.1.0&w=2200";

const FADE_IN = {
  initial: { opacity: 0 },
  whileInView: { opacity: 1 },
  viewport: { once: true },
  transition: { duration: 1 },
};

const RISE_IN = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.8 },
};

export default function WarningDivider() {
  return (
    <section
      className="relative border-b-2 border-current overflow-hidden"
      data-testid="warning-divider"
    >
      <div
        className="absolute inset-0 -z-10 duotone-strong"
        style={{
          backgroundImage: `url(${WARNING_IMG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        aria-hidden
      />
      <div
        className="absolute inset-0 -z-10"
        style={{
          background:
            "linear-gradient(180deg, hsl(var(--background)) 0%, hsl(var(--background) / 0.25) 50%, hsl(var(--background)) 100%)",
        }}
        aria-hidden
      />
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-32 md:py-40 text-center">
        <motion.p {...FADE_IN} className="eyebrow">
          On the brink · then & now
        </motion.p>
        <motion.h2
          {...RISE_IN}
          className="font-display uppercase font-bold mt-4 text-5xl md:text-8xl leading-[0.88] tracking-tight max-w-5xl mx-auto"
        >
          Nuclear war can <span className="text-[hsl(var(--primary))]">end</span> the way we live.
          <br />It cannot be <span className="italic">won</span>. It can only be <span className="italic">lost</span>.
        </motion.h2>
        <p className="font-serif-display italic mt-8 text-xl md:text-2xl opacity-80">
          — Ken Keyes, Jr., 1981. Forty-five years later, the missiles are still there.
        </p>
      </div>
    </section>
  );
}
